import React, { Component } from 'react';
import { observer } from 'mobx-react';
import axios from 'axios';
import '@availity/yup';
import {
	Form,
	Field,
	FormGroup,
	Radio,
	RadioGroup,
	CheckboxGroup,
	Checkbox
} from '@availity/form';
import { SelectField, ResourceSelect } from '@availity/select';
import { DateField } from '@availity/date';
import AvApi from '@availity/api-axios';
import { Button, Label, Row, Col, UncontrolledTooltip, UncontrolledAlert } from 'reactstrap';
import * as yup from 'yup';
import { Redirect } from 'react-router-dom';
import moment from 'moment';
import PropTypes from 'prop-types';
import currencyFormat from '../../Common/utilities/formatcurrency';
import CustomProgressBar from '../../Common/components/CustomProgressBar';
import awardeestore from '../stores/awardeestore';
import AmountCheckbox from './components/AmountCheckbox';
import AwardeeMiscExpense from './components/AwardeeMiscExpense';

@observer
export default class ProviderAwardeeInfo extends Component {
	constructor(props) {
		super(props);

		this.state = {
			redirectToLanding: false,
			redirectToHousingProfile: false,
			userInput: '',
			enableProviderAgency: false,
			showInfo: false,
		}

		if (awardeestore.getAwardeeHousingPageStatus('#providerinfo') !== 'stepwizard-step active') {
			awardeestore.setAwardeeHousingPageStatus('#providerinfo', 'active');
		}
		
		if(window.performance) {
			if(performance.navigation.type == 1) {
				awardeestore.resetAwardeeHousingPageStatus();
				window.location.href = '#';
			}
		}
	}

	componentDidMount() {
		if (awardeestore.getCountyListCount() === 0) {
			const URL = "/ahahawardeeprofileform/wa/configupdate/assessment.config";
			axios({
				method: 'get',
				url: URL,
			})
				.then(function (response) {
					awardeestore.setCountyList(response.data["assessment.config"][0].codeValues);
				})
				.catch(function (error) {
					return error;
				});
		}

		axios.post('/ahahawardeeprofileform/wa/api/v1/provconn/provider/agency/lookup',
			{
				q: "verify",
				limit: 1,
				offset: 0,
				searchKey: "verify"
			})
				.then(res => {
					this.setState({ enableProviderAgency: true });
				}).catch(error => {
					if(error.response.status === 404){
						this.setState({ enableProviderAgency: false });
					}
				});
		window.onpopstate = () => {
			this.props.history.go(1);
		}
	}

	setProviderInformation = event => {
		const { name, value } = event.target;
		awardeestore.setProviderInfo(name, value);
	}

	setAwardeePhone = event => {
		const { value } = event.target;
		awardeestore.setAwardeePhoneNumber(value);
	}

	setAwardeeProviderOneId = event => {
		const { value } = event.target;
		awardeestore.setAwardeeProvOne(value);
	}

	setAwardeePhoneType = value => {
		awardeestore.setAwardeePhoneType(value);
	}

	setAwardeeDOB = value => {
		awardeestore.setAwardeeDateOfBirth(value);
	}

	setAwardeeInformation = event => {
		const { name, value } = event.target;
		awardeestore.setAwardeeInfo(name, value);
	}

	setAwardeeInfoCounty = value => {
		awardeestore.setAwardeeInfoCounty(value);
	}

	setAwardeeMonthlyGross = event => {
		const { value } = event.target;
		awardeestore.setAwardeeMonthlyGrossIncome(value);
	}

	setIncomeSource = value => {
		const { incomeSourceData } = awardeestore;
		const incomeSourceObj = value.map((src) => (
			{
				source: src,
				amount: incomeSourceData[incomeSourceData.findIndex((incomeSrc) => incomeSrc.source === src)]?.amount
			}
		));

		awardeestore.setIncomeCategories(value);
		awardeestore.setIncomeSourceData(incomeSourceObj);
	}

	setCheckboxAmount = (source, event) => {
		const { value } = event.target;
		const { incomeSourceData } = awardeestore;

		const index = incomeSourceData.findIndex((src) => src.source === source);

		awardeestore.setIncomeCatAmount(value, index);
	}

	formatCheckboxAmount = (source, event) => {
		const { value } = event.target;
		const { incomeSourceData } = awardeestore;
		
		const index = incomeSourceData.findIndex((src) => src.source === source);

		awardeestore.setIncomeCatAmount(currencyFormat.formatToCurrency(value), index);
	}

	setShortTermRental = value => {
		awardeestore.setAShortTermRental(value);
		if(value === 'Yes') {
			awardeestore.setAwardeeRentalAssistProgram('');
			awardeestore.setAwardeRentalAssisProgramStartDate('');
			awardeestore.setAwardeRentalAssisProgramEndDate('');
			awardeestore.setAwardeeInfo('awardeeInfoRentalAssisProgramNotes', '');
			awardeestore.setAwardeeInfo('awardeeInfoRentalAssisProgramAmount', '');
		}
	}

	setMiscExpenses = value => {
		awardeestore.setAMiscExpenses(value);
		awardeestore.resetAwardeeMiscExpenses();

		if (value === 'Yes') {
			awardeestore.addAwardeeMiscExpense()
		}
	}

	setMiscExpenseType = (event, index) => {
		const { value } = event.target;

		awardeestore.setMiscExpenseType(index, value);
	}

	setMiscAwardeeAmount = (event, index) => {
		const { value } = event.target;

		awardeestore.setMiscExpenseAmount(index, value);
	}

	formatMiscAwardeeAmount = (event, index) => {
		const { value } = event.target;

		awardeestore.setMiscExpenseAmount(index, currencyFormat.formatToCurrency(value));
	}

	setAwardeeMiscExpenseType = (value, index) => {
		awardeestore.setMiscExpenseSelected(index, value);
	}

	setAwardeeMiscAmount = (event, index) => {
		const { value } = event.target;
		awardeestore.setMiscExpenseAmount(index, value);
	}

	addNewMiscExpense = () => {
		awardeestore.addAwardeeMiscExpense()
	}

	removeAwardeeMiscExpense = index => {
		awardeestore.removeAwardeeMiscExpense(index);
	}

	setOtherHousingAssist = value => {
		awardeestore.setAOtherHousing(value);
		if (value === 'No')
			awardeestore.setHousingDescription('');
	}

	setAwardeeRentalAssistProgram = value => {
		awardeestore.setAwardeeRentalAssistProgram(value);
	}

	setAwardeRentalAssisProgramStartDate = value => {
		awardeestore.setAwardeRentalAssisProgramStartDate(value);
	}

	setAwardeRentalAssisProgramEndDate = value => {
		awardeestore.setAwardeRentalAssisProgramEndDate(value);
	}

	generateInitValues = () => {
		const { awardeeMiscExpenseList } = awardeestore;
		const initialValuesMiscExp = {};

		awardeeMiscExpenseList.forEach((exp, i) => {
			initialValuesMiscExp[`miscExpense${i}`] = exp.expType;
			initialValuesMiscExp[`miscAmount${i}`] = exp.amount;
			initialValuesMiscExp[`miscType${i}`] = exp.type;
		})

		return initialValuesMiscExp;
	}

	generateValidation = () => {
		const { awardeeMiscExpenseList } = awardeestore;
		const miscExpenseComponentShape = {};

		for (let i = 0; i < awardeeMiscExpenseList.length; i++) {
			miscExpenseComponentShape[`miscExpense${i}`] = yup.string().matches(/^[A-Za-z0-9 \',\^\-ÄäÖöÜü]+$/, 'Miscellaneous Expense Type should be alpha-numeric').required('Please enter a value before continuing!');
			miscExpenseComponentShape[`miscAmount${i}`] = yup.string().matches(/^[\d]+(\.[\d]{2})?$/, 'Please enter the amount in the correct format!').required('Please enter a value before continuing!');
			miscExpenseComponentShape[`miscType${i}`] = yup.string().required('Please select an expense type before continuing!');
		}

		return miscExpenseComponentShape;
	}

	setHousingDescArea = event => {
		const { value } = event.target;
		awardeestore.setHousingDescription(value);
	}

	goBack = () => {
		this.setState({ redirectToLanding: true });
	}

	submit = () => {
		awardeestore.completedSteps.providerinfo = true;
		this.setState({ redirectToHousingProfile: true });
	}

	onChangeProvAgencyName = (selectedProvAgencyName) => {
		if (awardeestore.getAttachmentCount() && awardeestore.getProvAgencyName(awardeestore.providerInformation) != selectedProvAgencyName.label){
			awardeestore.resetAllDocumentObj();
			this.setState({showInfo: true});
		}
		if (selectedProvAgencyName) {
			awardeestore.setProviderInfo('provAgencyName', selectedProvAgencyName)
		}
	}

	formatToCurrency(value) {
    return (Math.round(value * 100) / 100).toFixed(2);
  }

	render() {
		const { userAgent } = navigator;
		const { redirectToHousingProfile, redirectToLanding, userInput, enableProviderAgency, showInfo } = this.state;
		const {
			awardeeHousingPages,
			providerInformation,
			awardeeInformation,
			phoneTypesList,
			awardeeMonthlyGross,
			incomeSourceCategories,
			incomeSourceData,
			aShortTermRental,
			aMiscExpenses,
			aOtherHousingAssist,
			awardeeMiscExpenseList,
			housingDescription,
			rentalAssistanceProgram,
			countyList
		} = awardeestore;

		const {
			agencyName,
			contactFirst,
			contactLast,
			contactEmail,
			contactPhone
		} = providerInformation;

		const {
			awardeeFirst,
			awardeeLast,
			awardeePreferredName,
			awardeeDOB,
			awardeeProvOneId,
			awardeePhone,
			awardeePhoneType,
			awardeeMailingAddr,
			awardeeCity,
			awardeeState,
			awardeeZip,
			awardeeCounty,
			awardeeRentalAssistanceProgram,
			awardeRentalAssisProgramStartDate,
			awardeRentalAssisProgramEndDate,
			awardeRentalAssisProgramAmount,
			awardeRentalAssisProgramNotes
		} = awardeeInformation;

		const initValues = this.generateInitValues();

		const validation = this.generateValidation();

		const provAgencyNameApi = new AvApi({
			api: '',
			url: '/ahahawardeeprofileform/wa/api/v1/provconn/provider/agency/lookup',
			transformRequest: (options) => JSON.stringify(options),
		});

		const { location } = this.props;

		const fromReviewAndSubmitPage = location && location.state && location.state.fromReviewAndSubmitPage;

		if (redirectToLanding) {
			return <Redirect to='/' />
		}

		if (redirectToHousingProfile) {
			return <Redirect to={fromReviewAndSubmitPage ? "/reviewAndSubmit" : "/housingprofile"} />
		}

		return (
			<>
				<div className='border-form'>
					<CustomProgressBar pages={awardeeHousingPages} />

					<div className='spacer-50' />

					<small className='required-fields'>*required</small>

					<div className='mt-5' />
					{showInfo  &&
							<Row className="pl-32 mt-3">
								<Col>
									<UncontrolledAlert color='danger' fade>
										<strong>
											Change in Provider Agency required all the docs to upload again..!
										</strong>
									</UncontrolledAlert>
								</Col>
							</Row>
						}

					<h2 className='poppinsH2'>
						Provider &amp; Awardee Information
					</h2>

					<div className='spacer-50' />

					<Form
						initialValues={{
							provAgencyName: agencyName,
							provContactFirst: contactFirst,
							provContactLast: contactLast,
							provContactEmail: contactEmail,
							provContactPhone: contactPhone,
							awardeeInfoFirst: awardeeFirst,
							awardeeInfoLast: awardeeLast,
							awardeeInfoPrefName: awardeePreferredName,
							awardeeDateOfBirth: awardeeDOB,
							awardeeProvOne: awardeeProvOneId,
							awardeeInfoPhone: awardeePhone,
							awardeeInfoPhoneType: awardeePhoneType,
							awardeeInfoCity: awardeeCity,
							awardeeInfoCounty: awardeeCounty,
							awardeeInfoZip: awardeeZip,
							awardIncomeAmount: awardeeMonthlyGross,
							awardeeIncomeSourceCheckbox: incomeSourceCategories.map(x => x),
							awardeeInfoRentalAssisProgramAmount: awardeRentalAssisProgramAmount,
							awardeeInfoRentalAssisProgramNotes: awardeRentalAssisProgramNotes,
							awardeeInfoRentalAssisProgramStartDate: awardeRentalAssisProgramStartDate,
							awardeeInfoRentalAssisProgramEndDate: awardeRentalAssisProgramEndDate,
							aShortTermRentalProgram: awardeeRentalAssistanceProgram,
							shortTermRentalRadio: aShortTermRental,
							miscExpensesRadio: aMiscExpenses,
							otherHousingAssistRadio: aOtherHousingAssist,
							ssaAmount: incomeSourceData[incomeSourceData.findIndex((src) => src.source === 'Social Security (SSA)')]?.amount,
							incTANFAmount: incomeSourceData[incomeSourceData.findIndex((src) => src.source === 'Temporary Assistance for Needy Families (TANF)')]?.amount,
							incEmploymentAmount: incomeSourceData[incomeSourceData.findIndex((src) => src.source === 'Employment')]?.amount,
							incPensionAmount: incomeSourceData[incomeSourceData.findIndex((src) => src.source === 'Pension')]?.amount,
							incHenAmount: incomeSourceData[incomeSourceData.findIndex((src) => src.source === 'Housing and Essential Needs (HEN)')]?.amount,
							incOtherAmount: incomeSourceData[incomeSourceData.findIndex((src) => src.source === 'Other')]?.amount,
							incSSIAmount: incomeSourceData[incomeSourceData.findIndex((src) => src.source === 'Supplemental Security Income (SSI)')]?.amount,
							incABDAmount: incomeSourceData[incomeSourceData.findIndex((src) => src.source === 'Aged, Blind, or Disabled (ABD)')]?.amount,
							incSSDIAmount: incomeSourceData[incomeSourceData.findIndex((src) => src.source === 'Social Security Disability Insurance (SSDI)')]?.amount,
							extHousingAssistArea: housingDescription,
							...initValues
						}}
						onSubmit={this.submit}
					validationSchema={yup.object().shape({
						provAgencyName: enableProviderAgency ? yup.object().required('Provider Agency Name is required.') : 
						yup.string().required('Provider Agency Name is required'),
						provContactFirst: yup.string()
							.matches(/^[A-Za-z0-9 \',\^\-ÄäÖöÜü]+$/, 'Provider Contact First Name should be alpha-numeric')
							.required('Provider Contact First Name is required'),
						provContactLast: yup.string()
							.matches(/^[A-Za-z0-9 \',\^\-ÄäÖöÜü]+$/, 'Provider Contact Last Name should be alpha-numeric')
							.required('Provider Contact Last Name is required'),
						provContactEmail: yup.string()
							.matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, 'Provider Contact Email should be standard email format (example@mail.com)')
							.required('Provider Contact Email is required'),
						provContactPhone: yup.string()
							.matches(/^\d{10}$/, 'Provider Contact Phone Number must be 10 digits with no hyphens')
							.required('Provider Contact Phone Number is required'),
						awardeeInfoFirst: yup.string()
							.matches(/^[A-Za-z0-9 \',\^\-ÄäÖöÜü]+$/, 'Awardee First Name should be alpha-numeric')
							.required('Awardee First Name is required'),
						awardeeInfoLast: yup.string()
							.matches(/^[A-Za-z0-9 \',\^\-ÄäÖöÜü]+$/, 'Awardee Last Name should be alpha-numeric')
							.required('Awardee Last Name is required'),
						awardeeInfoPrefName: yup.string()
							.matches(/^[A-Za-z0-9 \',\^\-ÄäÖöÜü]+$/, 'Awardee Preferred Name should be alpha-numeric'),
						awardeeDateOfBirth: yup.date()
							.max(moment().subtract(16, 'years').format('MM/DD/YYYY'), 'Date of Birth must be at least 16 years old.')
							.required('Awardee Date of Birth is required')
							.typeError('Please enter in correct date format (MM/DD/YYYY)'),
						awardeeProvOne: yup.string()
							.min(9, 'Please enter 9 digits')
							.matches(/\d{9}/, 'Provider Id should be only 9 digits, no special characters or alphabets')
							.required('Provider One Id is required'),
						awardeeInfoPhone: yup.string()
							.matches(/^\d{10}$/, 'Awardee Phone Number must be 10 digits with no hyphens'),
						awardeeInfoCity: yup.string()
							.matches(/^[A-Za-z0-9 \',\^\-ÄäÖöÜü]+$/, 'Provider City should be alpha-numeric')
							.required('Awardee City is required'),
						awardeeInfoCounty: yup.string()
							.matches(/^[A-Za-z0-9 \',\^\-ÄäÖöÜü]+$/, 'Provider County should be alpha-numeric')
							.required('Awardee County is required'),
						awardeeInfoZip: yup.string()
							.min(5, 'Awardee Zip Code should be at least 5 digits'),
						awardIncomeAmount: yup.string()
									.matches(/^(0(\.00)?|[1-9]\d*(\.\d{1,2})?)$/, 'Please enter the amount in the correct format!')
									.required('Please enter awardee monthly gross income'),
								
						shortTermRentalRadio: yup.string()
							.required('Please select an option before continuing!'),
						miscExpensesRadio: yup.string()
							.required('Please select an option before continuing!'),
						otherHousingAssistRadio: yup.string()
							.required('Please select an option before continuing!'),
						awardeeIncomeSourceCheckbox: yup.array().min(1, 'Please select an option before continuing!'),
						ssaAmount: yup.string()
							.matches(/^[\d]+(\.[\d]{2})?$/, 'Please enter the amount in the correct format!')
							.isRequired(incomeSourceCategories.indexOf('Social Security (SSA)') >= 0,'Please enter a value before continuing!'),
						incTANFAmount: yup.string()
							.matches(/^[\d]+(\.[\d]{2})?$/, 'Please enter the amount in the correct format!')
							.isRequired(incomeSourceCategories.indexOf('Temporary Assistance for Needy Families (TANF)') >= 0, 'Please enter a value before continuing!'),
						incEmploymentAmount: yup.string()
							.matches(/^[\d]+(\.[\d]{2})?$/, 'Please enter the amount in the correct format!')
							.isRequired(incomeSourceCategories.indexOf('Employment') >= 0, 'Please enter a value before continuing!'),
						incPensionAmount: yup.string()
							.matches(/^[\d]+(\.[\d]{2})?$/, 'Please enter the amount in the correct format!')
							.isRequired(incomeSourceCategories.indexOf('Pension') >= 0, 'Please enter a value before continuing!'),
						incHenAmount: yup.string()
							.matches(/^[\d]+(\.[\d]{2})?$/, 'Please enter the amount in the correct format!')
							.isRequired(incomeSourceCategories.indexOf('Housing and Essential Needs (HEN)') >= 0, 'Please enter a value before continuing!'),
						incOtherAmount: yup.string()
							.matches(/^[\d]+(\.[\d]{2})?$/, 'Please enter the amount in the correct format!')
							.isRequired(incomeSourceCategories.indexOf('Other') >= 0, 'Please enter a value before continuing!'),
						incSSIAmount: yup.string()
							.matches(/^[\d]+(\.[\d]{2})?$/, 'Please enter the amount in the correct format!')
							.isRequired(incomeSourceCategories.indexOf('Supplemental Security Income (SSI)') >= 0, 'Please enter a value before continuing!'),
						incABDAmount: yup.string()
							.matches(/^[\d]+(\.[\d]{2})?$/, 'Please enter the amount in the correct format!')
							.isRequired(incomeSourceCategories.indexOf('Aged, Blind, or Disabled (ABD)') >= 0, 'Please enter a value before continuing!'),
						incSSDIAmount: yup.string()
							.matches(/^[\d]+(\.[\d]{2})?$/, 'Please enter the amount in the correct format!')
							.isRequired(incomeSourceCategories.indexOf('Social Security Disability Insurance (SSDI)') >= 0, 'Please enter a value before continuing!'),
						aShortTermRentalProgram: yup.string()
							.isRequired(aShortTermRental === 'Yes', 'Please select an option before continuing!'),
						awardeeInfoRentalAssisProgramNotes: yup.string()
							.isRequired(aShortTermRental === 'Yes','Please enter Notes before continuing!'),
						awardeeInfoRentalAssisProgramStartDate: yup.date()
							.max(moment().format('MM/DD/YYYY'), 'Start Date cannot be in the future')
							.typeError('Please enter a start date!'),
						awardeeInfoRentalAssisProgramEndDate: yup.date()
							.min(awardeRentalAssisProgramStartDate != '' ? moment(awardeRentalAssisProgramStartDate).format('MM/DD/YYYY') : moment('01/01/1968'), 'End Date cannot be before start date')
							.typeError('Please enter an end date!'),
						awardeeInfoRentalAssisProgramAmount: yup.string()
							.matches(/^[\d]+(\.[\d]{2})?$/, 'Please enter the amount in the correct format!')
							.isRequired(aShortTermRental == 'Yes', 'Please enter Amount'),
							...(aOtherHousingAssist === 'Yes' ? {extHousingAssistArea: yup.string().required('Please enter a value before continuing!')} : {}),
						...validation
					})}
					>
						<div className='spacer-50' />
						<h5 className='poppinsH5'>
							Provider Information
						</h5>

						<Row>
							<Col sm='4'>
							{ 
							enableProviderAgency ? 
								<ResourceSelect
									label={
										<>
											<Label id="provAgencyName-label" htmlFor="provAgencyName">
												Provider Agency Name*
												<span id="provAgencyName-help" className="inline-help" />
											</Label>
											<div id="providerAgencyNameHelp">
												<small className='form-text text-muted prov-agency-name-help'>
													Enter minimum 3 characters and continue to enter to find the exact match.
												</small>
											</div>
											<UncontrolledTooltip target="provAgencyName-help" placement="right" innerClassName="text-left">
												Enter minimum 3 characters and continue to enter to find the exact match.
											</UncontrolledTooltip>
										</>
									}
									id="provAgencyNameId"
									name="provAgencyName"
									className='straighten-borders'
									placeholder="Select Provider Agency Name"
									onChange={this.onChangeProvAgencyName}
									resource={provAgencyNameApi}
									shouldSearch={(_inputValue) => _inputValue.length > 2}
									onInputChange={(searchInput) => this.setState({ userInput: searchInput })}
									parameters={{
										searchKey: `${userInput}`,
									}}
									waitUntilFocused
									getResult={(data) =>
										data.names.map((val) => ({
											value: val.id,
											label: val.name,
											abbr: val.abbr
										}))
									}
									method='POST'
								/>
								:
								<FormGroup htmlFor='provAgencyName' className='label-font'>
									<Label htmlFor='provAgencyName'>
										Provider Agency Name*
									</Label>
									<Field 
										type="text"
										id="provAgencyName"
										name="provAgencyName"
										className='straighten-borders'
										onChange={this.setProviderInformation}
										value={agencyName}
										maxLength={50}
									/>
								</FormGroup>
							}
							</Col>
						</Row>

						<Row>
							<Col sm='4'>
								<FormGroup for='provContactFirst' className='label-font'>
									<Label htmlFor='provContactFirst'>
										Provider Contact First Name*
									</Label>
									<Field
										type='text'
										id='provContactFirst'
										name='provContactFirst'
										className='straighten-borders'
										onChange={this.setProviderInformation}
										value={contactFirst}
										maxLength={50}
									/>
								</FormGroup>
							</Col>
							<Col sm='4'>
								<FormGroup for='provContactLast' className='label-font'>
									<Label htmlFor='provContactLast'>
										Provider Contact Last Name*
									</Label>
									<Field
										type='text'
										id='provContactLast'
										name='provContactLast'
										className='straighten-borders'
										onChange={this.setProviderInformation}
										value={contactLast}
										maxLength={50}
									/>
								</FormGroup>
							</Col>
						</Row>

						<Row>
							<Col sm='4'>
								<FormGroup for='provContactEmail' className='label-font'>
									<Label htmlFor='provContactEmail'>
										Provider Contact Email*
									</Label>
									<Field
										type='text'
										id='provContactEmail'
										name='provContactEmail'
										className='straighten-borders'
										onChange={this.setProviderInformation}
										value={contactEmail}
										maxLength={50}
									/>
								</FormGroup>
							</Col>
							<Col sm='4'>
								<FormGroup for='provContactPhone' className='label-font'>
									<Label htmlFor='provContactPhone'>
										Provider Contact Phone*
									</Label>
									<Field
										type='text'
										id='provContactPhone'
										name='provContactPhone'
										className='straighten-borders'
										onChange={this.setProviderInformation}
										value={contactPhone}
										maxLength={10}
									/>
								</FormGroup>
							</Col>
						</Row>

						<hr />

						<h5 className='poppinsH5'>
							Awardee Information
						</h5>

						<Row>
							<Col sm='4'>
								<FormGroup for='awardeeInfoFirst' className='label-font'>
									<Label htmlFor='awardeeInfoFirst'>
										First Name*
									</Label>
									<Field
										type='text'
										id='awardeeInfoFirst'
										name='awardeeInfoFirst'
										className='straighten-borders'
										onChange={this.setAwardeeInformation}
										value={awardeeFirst}
										maxLength={50}
									/>
								</FormGroup>
							</Col>
							<Col sm='4'>
								<FormGroup for='awardeeInfoLast' className='label-font'>
									<Label htmlFor='awardeeInfoLast'>
										Last Name*
									</Label>
									<Field
										type='text'
										id='awardeeInfoLast'
										name='awardeeInfoLast'
										className='straighten-borders'
										onChange={this.setAwardeeInformation}
										value={awardeeLast}
										maxLength={50}
									/>
								</FormGroup>
							</Col>
							<Col sm='4'>
								<FormGroup for='awardeeInfoPrefName' className='label-font'>
									<Label htmlFor='awardeeInfoPrefName'>
										Preferred Name
									</Label>
									<Field
										type='text'
										id='awardeeInfoPrefName'
										name='awardeeInfoPrefName'
										className='straighten-borders'
										onChange={this.setAwardeeInformation}
										value={awardeePreferredName}
										maxLength={50}
									/>
								</FormGroup>
							</Col>
						</Row>

						<Row>
							<Col sm='3'>
								<FormGroup for='awardeeDateOfBirth' className='label-font'>
									<DateField
										id='awardeeDateOfBirth'
										name='awardeeDateOfBirth'
										label='Date of Birth*'
										value={awardeeDOB}
										className='straighten-borders'
										onChange={this.setAwardeeDOB}
										datePickerProps={{
											showDefaultInputIcon: true,
											inputIconPosition: 'after',
											autoComplete: /edg/i.test(userAgent) ? 'autofill-off-edge' : 'off',
										}}
									/>
								</FormGroup>
							</Col>
							<Col className='pr-0' sm='3'>
								<FormGroup for='awardeeProvOne' className='label-font'>
									<Field
										type="text"
										name="awardeeProvOne"
										id="awardeeProvOne"
										className="straighten-borders"
										label="ProviderOne ID*"
										value={awardeeProvOneId}
										onChange={this.setAwardeeProviderOneId}
										maxLength={9}
									/>
								</FormGroup>
							</Col>
							<Col className='pl-0' sm='1'>
								<FormGroup for='wash_suffix' className='label-font'>
									<Field
										type='text'
										id='wash_suffix'
										aria-label='wash_suffix'
										name='wash_suffix'
										className='straighten-borders stateCode-suffix'
										value='WA'
										disabled
									/>
								</FormGroup>
							</Col>
						</Row>
						<Row>
							<Col sm='4'>
								<FormGroup for='awardeeInfoPhone' className='label-font'>
									<Label htmlFor='awardeeInfoPhone'>
										Phone
									</Label>
									<Field
										type='text'
										id='awardeeInfoPhone'
										name='awardeeInfoPhone'
										className='straighten-borders'
										onChange={this.setAwardeePhone}
										value={awardeePhone}
										maxLength={10}
									/>
								</FormGroup>
							</Col>
							<Col sm='2'>
								<Label className='label-font' htmlFor='awardeeInfoPhoneType'>
									Phone Type
								</Label>
								<FormGroup for='awardeeInfoPhoneType' className='label-font'>
									<SelectField
										type='select'
										name='awardeeInfoPhoneType'
										className='straighten-borders'
										placeholder="Select"
										value={awardeePhoneType}
										onChange={this.setAwardeePhoneType}
										options={phoneTypesList.map(type => (
											{
												value: type.value,
												label: type.id
											}
										))}
									/>
								</FormGroup>
							</Col>
						</Row>

						<div className='mt-5' />

						<h6 className='label-font'>
							<b>Please provide a mailing address, if available.</b>
						</h6>
						<p className='label-font'>
							The awardee will receive a letter containing more details about the AHAH Rental Assistance
							Program voucher at the address provided
						</p>

						<h6 className='poppinsH6 label-font'>
							<b>Otherwise, enter city and county of awardee's residence.</b>
						</h6>

						<div className='mt-5' />

						<Row>
							<Col sm='6'>
								<FormGroup for='awardeeInfoAddr' className='label-font'>
									<Label htmlFor='awardeeInfoAddr'>
										Mailing Address (Optional)
									</Label>
									<Field
										type='text'
										id='awardeeInfoAddr'
										name='awardeeInfoAddr'
										className='straighten-borders'
										onChange={this.setAwardeeInformation}
										value={awardeeMailingAddr}
										maxLength={100}
									/>
								</FormGroup>
							</Col>
							<Col sm='6'>
								<FormGroup for='awardeeInfoCity' className='label-font'>
									<Label htmlFor='awardeeInfoCity'>
										City*
									</Label>
									<Field
										type='text'
										id='awardeeInfoCity'
										name='awardeeInfoCity'
										className='straighten-borders'
										onChange={this.setAwardeeInformation}
										value={awardeeCity}
										maxLength={50}
									/>
								</FormGroup>
							</Col>
						</Row>

						<Row>
							<Col sm='2'>
								<FormGroup for='awardeeInfoState' className='label-font'>
									<Field
										type='text'
										id='awardeeInfoState'
										name='awardeeInfoState'
										className='straighten-borders'
										label='State'
										value={awardeeState}
										readOnly
									/>
								</FormGroup>
							</Col>
							<Col sm='2'>
								<FormGroup for='awardeeInfoZip' className='label-font'>
									<Label htmlFor='awardeeInfoZip'>
										Zip
									</Label>
									<Field
										type='text'
										id='awardeeInfoZip'
										name='awardeeInfoZip'
										className='straighten-borders'
										onChange={this.setAwardeeInformation}
										value={awardeeZip}
										maxLength={5}
									/>
								</FormGroup>
							</Col>
							<Col sm='4'>
								<FormGroup for='awardeeInfoCounty' className='label-font'>
									{/* <Label htmlFor='awardeeInfoCounty'>
										County*
									</Label> */}
									{/* <Field
										type='text'
										id='awardeeInfoCounty'
										name='awardeeInfoCounty'
										className='straighten-borders'
										onChange={this.setAwardeeInformation}
										value={awardeeCounty}
										maxLength={50}
									/> */}
									<SelectField
										name="awardeeInfoCounty"
										label="County*"
										className="straighten-borders pTypeList"
										value={awardeeCounty}
										onChange={this.setAwardeeInfoCounty}
										options={countyList.map(county => (
											{
												value: county.code, label: county.value
											}
										))}
									/>
								</FormGroup>
							</Col>
						</Row>

						<div className='mt-5' />

						<UncontrolledTooltip target='incomeTip' placement='top'>
							Income inclusions and exclusions are listed in the Electronic Code of Federal Regulations,
							www.ecfr.gov, Title 24 - Housing and Urban Development: Subtitle A 0-99: Part 5: Subpart F:
							Section 5.609 Annual Income.
						</UncontrolledTooltip>
						<div className='mb-5'>
							<span>
								<b>Monthly Gross Income* </b>
								<i className='icon icon-info-circle info-link' id='incomeTip' />
								<span className='info-link'>Income Inclusions/Exclusions</span>
							</span>
						</div>

						<Row>
							<Col sm='2'>
								<FormGroup for='awardeeIncomeAmount' className='label-font'>
									<Label htmlFor='awardeeIncomeAmount'>
										Amount
									</Label>
									<div>
										<span className='dollar-sign'>&#36;</span>
										<Field
											type='text'
											id='awardeeIncomeAmount'
											name='awardIncomeAmount'
											className='straighten-borders right-text'
											onChange={this.setAwardeeMonthlyGross}
											onBlur={(e) => awardeestore.setAwardeeMonthlyGrossIncome(currencyFormat.formatToCurrency(e.target.value))}
											value={awardeeMonthlyGross}
											maxLength={6}
										/>
									</div>
								</FormGroup>
							</Col>
						</Row>

						<div className='spacer-rem' />

						<div className='mb-5'>
							<b>Income Source* </b>
						</div>

						<CheckboxGroup name='awardeeIncomeSourceCheckbox' value={incomeSourceCategories} onChange={this.setIncomeSource}>
							<Row>
								<Col sm='4'>
									<Checkbox
										className='label-font no-display'
										label='Social Security (SSA)'
										name='incSocialSecurity'
										value='Social Security (SSA)'
									/>
									{
										(incomeSourceCategories.indexOf('Social Security (SSA)') >= 0) &&
										(
											<AmountCheckbox
												fieldId='ssaAmount'
												fieldName='ssaAmount'
												fieldVal={incomeSourceData[incomeSourceData.findIndex((src) => src.source === 'Social Security (SSA)')].amount}
												changeFunc={(e) => this.setCheckboxAmount('Social Security (SSA)', e)}
												blurFunc={(e) => this.formatCheckboxAmount('Social Security (SSA)', e)}
											/>
										)
									}
								</Col>
								<Col className='' sm='5'>
									<Checkbox
										className='label-font no-display'
										label='Temporary Assistance for Needy Families (TANF)'
										name='incTANF'
										value='Temporary Assistance for Needy Families (TANF)'
									/>
									{
										(incomeSourceCategories.indexOf('Temporary Assistance for Needy Families (TANF)') >= 0) &&
										(
											<AmountCheckbox
												fieldId='incTANFAmount'
												fieldName='incTANFAmount'
												fieldVal={incomeSourceData[incomeSourceData.findIndex((src) => src.source === 'Temporary Assistance for Needy Families (TANF)')].amount}
												changeFunc={(e) => this.setCheckboxAmount('Temporary Assistance for Needy Families (TANF)', e)}
												blurFunc={(e) => this.formatCheckboxAmount('Temporary Assistance for Needy Families (TANF)', e)}
											/>
										)
									}
								</Col>
								<Col sm='3'>
									<Checkbox
										className='label-font no-display'
										label='Employment'
										name='incEmployment'
										value='Employment'
									/>
									{
										(incomeSourceCategories.indexOf('Employment') >= 0) &&
										(
											<AmountCheckbox
												fieldId='incEmploymentAmount'
												fieldName='incEmploymentAmount'
												fieldVal={incomeSourceData[incomeSourceData.findIndex((src) => src.source === 'Employment')].amount}
												changeFunc={(e) => this.setCheckboxAmount('Employment', e)}
												blurFunc={(e) => this.formatCheckboxAmount('Employment', e)}
											/>
										)
									}
								</Col>
							</Row>
						</CheckboxGroup>

						<CheckboxGroup name='awardeeIncomeSourceCheckbox' value={incomeSourceCategories} onChange={this.setIncomeSource}>
							<Row>
								<Col sm='4'>
									<Checkbox
										className='label-font mb-5 no-display'
										label='Pension'
										name='incPension'
										value='Pension'
									/>
									{
										(incomeSourceCategories.indexOf('Pension') >= 0) &&
										(
											<AmountCheckbox
												fieldId='incPensionAmount'
												fieldName='incPensionAmount'
												fieldVal={incomeSourceData[incomeSourceData.findIndex((src) => src.source === 'Pension')].amount}
												changeFunc={(e) => this.setCheckboxAmount('Pension', e)}
												blurFunc={(e) => this.formatCheckboxAmount('Pension', e)}
											/>
										)
									}
								</Col>
								<Col sm='5'>
									<Checkbox
										className='label-font no-display'
										label='Housing and Essential Needs (HEN)'
										name='incHEN'
										value='Housing and Essential Needs (HEN)'
									/>
									{
										(incomeSourceCategories.indexOf('Housing and Essential Needs (HEN)') >= 0) &&
										(
											<AmountCheckbox
												fieldId='incHenAmount'
												fieldName='incHenAmount'
												fieldVal={incomeSourceData[incomeSourceData.findIndex((src) => src.source === 'Housing and Essential Needs (HEN)')].amount}
												changeFunc={(e) => this.setCheckboxAmount('Housing and Essential Needs (HEN)', e)}
												blurFunc={(e) => this.formatCheckboxAmount('Housing and Essential Needs (HEN)', e)}
											/>
										)
									}
								</Col>
								<Col sm='3'>
									<Checkbox
										className='label-font no-display'
										label='Other'
										name='incOther'
										value='Other'
									/>
									{
										(incomeSourceCategories.indexOf('Other') >= 0) &&
										(
											<AmountCheckbox
												fieldId='incOtherAmount'
												fieldName='incOtherAmount'
												fieldVal={incomeSourceData[incomeSourceData.findIndex((src) => src.source === 'Other')].amount}
												changeFunc={(e) => this.setCheckboxAmount('Other', e)}
												blurFunc={(e) => this.formatCheckboxAmount('Other', e)}
											/>
										)
									}
								</Col>
							</Row>
						</CheckboxGroup>

						<CheckboxGroup name='awardeeIncomeSourceCheckbox' value={incomeSourceCategories} onChange={this.setIncomeSource}>
							<Row>
								<Col sm='4'>
									<Checkbox
										className='label-font no-display'
										label='Supplemental Security Income (SSI)'
										name='incSSI'
										value='Supplemental Security Income (SSI)'
									/>
									{
										(incomeSourceCategories.indexOf('Supplemental Security Income (SSI)') >= 0) &&
										(
											<AmountCheckbox
												fieldId='incSSIAmount'
												fieldName='incSSIAmount'
												fieldVal={incomeSourceData[incomeSourceData.findIndex((src) => src.source === 'Supplemental Security Income (SSI)')].amount}
												changeFunc={(e) => this.setCheckboxAmount('Supplemental Security Income (SSI)', e)}
												blurFunc={(e) => this.formatCheckboxAmount('Supplemental Security Income (SSI)', e)}
											/>
										)
									}
								</Col>
								<Col sm='4'>
									<Checkbox
										className='label-font no-display'
										label='Aged, Blind, or Disabled (ABD)'
										name='incABD'
										value='Aged, Blind, or Disabled (ABD)'
									/>
									{
										(incomeSourceCategories.indexOf('Aged, Blind, or Disabled (ABD)') >= 0) &&
										(
											<AmountCheckbox
												fieldId='incABDAmount'
												fieldName='incABDAmount'
												fieldVal={incomeSourceData[incomeSourceData.findIndex((src) => src.source === 'Aged, Blind, or Disabled (ABD)')].amount}
												changeFunc={(e) => this.setCheckboxAmount('Aged, Blind, or Disabled (ABD)', e)}
												blurFunc={(e) => this.formatCheckboxAmount('Aged, Blind, or Disabled (ABD)', e)}
											/>
										)
									}
								</Col>
							</Row>
						</CheckboxGroup>

						<CheckboxGroup name='awardeeIncomeSourceCheckbox' value={incomeSourceCategories} onChange={this.setIncomeSource}>
							<Row>
								<Col sm='5'>
									<Checkbox
										className='label-font no-display'
										label='Social Security Disability Insurance (SSDI)'
										name='incSSDI'
										value='Social Security Disability Insurance (SSDI)'
									/>
									{
										(incomeSourceCategories.indexOf('Social Security Disability Insurance (SSDI)') >= 0) &&
										(
											<AmountCheckbox
												fieldId='incSSDIAmount'
												fieldName='incSSDIAmount'
												fieldVal={incomeSourceData[incomeSourceData.findIndex((src) => src.source === 'Social Security Disability Insurance (SSDI)')].amount}
												changeFunc={(e) => this.setCheckboxAmount('Social Security Disability Insurance (SSDI)', e)}
												blurFunc={(e) => this.formatCheckboxAmount('Social Security Disability Insurance (SSDI)', e)}
											/>
										)
									}
								</Col>
							</Row>
						</CheckboxGroup>

						<div className='spacer-3rem' />

						<UncontrolledTooltip target='costTip' placement='top'>
							Rental Assistance - AHAH/PSH (Permanent Supportive Housing) unit expects that,
							when other short-term subsidies are available for emergency housing, securing
							housing costs, and move-in costs, that these subsidies are used before
							TBRA/PBRA (Tenant Based Rental Assistance/Project Based Rental Assistance) funds
						</UncontrolledTooltip>
						<div>
							<span>
								<b>
									Is the awardee utilizing a time-limited short-term rental resource
									to cover any costs?*
								</b>
								<i className='icon icon-info-circle info-link' id='costTip' />
								<span className='info-link'>Expectations of Cost Utilization</span>
							</span>
						</div>

						<RadioGroup name='shortTermRentalRadio' value={aShortTermRental} onChange={this.setShortTermRental}>
							<Radio className='label-font-round shortTermRentalOpt' label='Yes' value='Yes' />
							<Radio className='label-font-round shortTermRentalOpt' label='No' value='No' />
						</RadioGroup>

						<div className='spacer-2rem' />

						{
							aShortTermRental == 'Yes' ?
								<div>
									<Row>
										<Col sm="4">
											<FormGroup for="aShortTermRentalProgram" className="label-font">
												<SelectField
													name="aShortTermRentalProgram"
													label="Select Program*"
													className="straighten-borders pTypeList"
													value={awardeeRentalAssistanceProgram}
													onChange={this.setAwardeeRentalAssistProgram}
													options={rentalAssistanceProgram.map(program => (
														{
															value: program.value, label: program.name
														}
													))}
												/>
											</FormGroup>
										</Col>
										<Col sm="3">
											<FormGroup for='awardeeInfoRentalAssisProgramStartDate' className='label-font'>
												<DateField
													id='awardeeInfoRentalAssisProgramStartDate'
													name='awardeeInfoRentalAssisProgramStartDate'
													label='Start Date*'
													value={awardeRentalAssisProgramStartDate}
													className='straighten-borders'
													required={aShortTermRental === 'Yes'}
													errorMessage={'Please enter start date!'}
													onChange={this.setAwardeRentalAssisProgramStartDate}
													datePickerProps={{
														autoComplete: /edg/i.test(userAgent) ? 'autofill-off-edge' : 'off',
													}}
													max={moment().format('MM/DD/YYYY')}
												/>
											</FormGroup>
										</Col>
										<Col sm="3">
											<FormGroup for='awardeeInfoRentalAssisProgramEndDate' className='label-font'>
												<DateField
													id='awardeeInfoRentalAssisProgramEndDate'
													name='awardeeInfoRentalAssisProgramEndDate'
													label='End Date*'
													value={awardeRentalAssisProgramEndDate}
													className='straighten-borders'
													required={aShortTermRental === 'Yes'}
													errorMessage={'Please enter end date!'}
													onChange={this.setAwardeRentalAssisProgramEndDate}
                                                    disabled={!awardeRentalAssisProgramStartDate}
													datePickerProps={{
														autoComplete: /edg/i.test(userAgent) ? 'autofill-off-edge' : 'off',
													}}
													{...(awardeRentalAssisProgramStartDate && { min: moment(awardeRentalAssisProgramStartDate).format('MM/DD/YYYY') })}
												/>
											</FormGroup>
										</Col>
										<Col sm='2'>
											<FormGroup for="awardeeInfoRentalAssisProgramAmount" className="label-font">
												<Label htmlFor="awardeeInfoRentalAssisProgramAmount">Amount*</Label>
												<div>
													<span className='dollar-sign'>&#36;</span>
													<Field
														type="text"
														name="awardeeInfoRentalAssisProgramAmount"
														id="awardeeInfoRentalAssisProgramAmount"
														className="straighten-borders right-text"
														value={awardeRentalAssisProgramAmount}
														onChange={this.setAwardeeInformation}
														onBlur={(e) => awardeestore.setAwardeeInfo('awardeeInfoRentalAssisProgramAmount', currencyFormat.formatToCurrency(e.target.value))}
														maxLength={6}
													/>
												</div>

											</FormGroup>
										</Col>
									</Row>
									<Row>
										<Col sm="3">
											<FormGroup for="awardeeInfoRentalAssisProgramNotes" className="label-font">
												<Field
													type="textarea"
													name="awardeeInfoRentalAssisProgramNotes"
													id="awardeeInfoRentalAssisProgramNotes"
													className="straighten-borders"
													label="Notes*"
													value={awardeRentalAssisProgramNotes}
													onChange={this.setAwardeeInformation}
													maxLength={2000}
												/>
												<Label style={{ display: 'block' }} className="small text-right">2000 Character max</Label>
											</FormGroup>
										</Col>
									</Row>
								</div>
								:
								null
						}

						<b>Does the awardee have any miscellaneous expenses?*</b>
						<RadioGroup name='miscExpensesRadio' value={aMiscExpenses} onChange={this.setMiscExpenses}>
							<Radio className='label-font-round miscExpensesOpt' label='Yes' value='Yes' />
							<Radio className='label-font-round miscExpensesOpt' label='No' value='No' />
						</RadioGroup>

						<div className='spacer' />

						{
							(aMiscExpenses !== 'No' && aMiscExpenses !== '') &&
							(
								<>
									{
										awardeeMiscExpenseList.map((exp, i) => (
											<>
												<AwardeeMiscExpense
													index={i}
													expenseType={exp.expType}
													setMiscExpenseType={this.setMiscExpenseType}
													setExpenseType={this.setAwardeeMiscExpenseType}
													miscAmount={exp.amount}
													expenseSelected={exp.type}
													setMiscAmount={this.setMiscAwardeeAmount}
													formatMiscAmount={this.formatMiscAwardeeAmount}
													removeExpense={this.removeAwardeeMiscExpense}
												/>
											</>
										))
									}
									{
										(awardeeMiscExpenseList.length < 10) &&
										(
											<>
												<Button type='button' color='link' className='btn expenseBtn' onClick={this.addNewMiscExpense}>
													<i className='icon icon-plus' />
													Add Another Expense
												</Button>
											</>
										)
									}
								</>

							)
						}

						<div className='spacer-2rem' />

						<b>Is the awardee receiving any other housing assistance?*</b>
						<RadioGroup name='otherHousingAssistRadio' value={aOtherHousingAssist} onChange={this.setOtherHousingAssist}>
							<Radio className='label-font-round otherHousingOpt' label='Yes' value='Yes' />
							<Radio className='label-font-round otherHousingOpt' label='No' value='No' />
						</RadioGroup>

						{
							aOtherHousingAssist === 'Yes' && (
								<>
									<Row>
										<Col sm='6' className='housingDescription'>
											<Label className='label-font' htmlFor='extHousingAssistArea'>
												Please describe*
											</Label>
											<Field
												type='textarea'
												id='extHousingAssistArea'
												name='extHousingAssistArea'
												className='straighten-borders form-control form-group'
												onChange={this.setHousingDescArea}
												value={housingDescription}
												row='6'
												col='600'
												maxLength={2000}
											/>
											<p className='small text-right mb-0 label-font'>2000 characters max.</p>
										</Col>
									</Row>
								</>
							)
						}


						<Button type="button" color={"primary"} className={'btn btn-primary straighten-borders buttonBack'} onClick={this.goBack}>
							Back
						</Button>
						<Button type="submit" color={"primary"} className={'btn btn-primary awardeeNextBtn mb-50'}>
							Next
						</Button>
					</Form>
				</div>
				<div className='pb-spacer9hRem' />
			</>
		);
	}
}

ProviderAwardeeInfo.propTypes = {
	history: PropTypes.object,
	location: PropTypes.shape({
		state: PropTypes.shape({
			fromReviewAndSubmitPage: PropTypes.bool
		})
	})
}
